const DESIGN_WIDTH = 360;
const DESIGN_HEIGHT = 800;
const CONTAINER_MAX_WIDTH = 
  (window.innerHeight < 640 || (window.innerWidth === 1280 && window.innerHeight === 720)) ? 320 : 500;

// const IPHONE6_START_THRESHOLD_HEIGHT = 667
// const IPHONE6_END_THRESHOLD_HEIGHT = 735
// const IPHONE7PLUS_END_THRESHOLD_HEIGHT = 736

// export const getWidth = (value) => {
//   return (value / DESIGN_WIDTH) * window.innerWidth;
// };

// export const getHeight = (value) => {
//   return (value / DESIGN_HEIGHT) * window.innerHeight;
// };

export const getWidth = (value) => {
  const screenWidth = Math.min(window.innerWidth, CONTAINER_MAX_WIDTH);
  return (value / DESIGN_WIDTH) * screenWidth;
};

export const getHeight = (value) => {
  const screenHeight = window.innerHeight;
  return (value / DESIGN_HEIGHT) * screenHeight;
};

export const getHeightCorrectedForIphone6 = (value) => {
  const deviceHeight = window.innerHeight;

  // Define constants for thresholds
  const IPHONE6_START_THRESHOLD_HEIGHT = 667; // Example height for iPhone 6/6s
  const IPHONE7PLUS_END_THRESHOLD_HEIGHT = 736; // Example height for iPhone 7 Plus
  const DESIGN_HEIGHT = 812; // Replace with your design's base height

  if (
    deviceHeight >= IPHONE6_START_THRESHOLD_HEIGHT &&
    deviceHeight <= IPHONE7PLUS_END_THRESHOLD_HEIGHT
  ) {
    // If within iPhone 6 range, apply specific correction
    return (value / DESIGN_HEIGHT) * deviceHeight * 1.2;
  }

  // Default scaling
  return (value / DESIGN_HEIGHT) * deviceHeight;
};

